import angular from 'angular'

class QuotationResultPotComponent {
    /** @ngInject */
    constructor(DeviceChecker, ContractDraft, ErrorCatcher) {
        this.isMobile = DeviceChecker.isMobile
        this.contractDraftService = ContractDraft
        this.errorCatcher = ErrorCatcher
        this.potSlider = {
            options: {
                floor: -15,
                ceil: 0,
                step: 5,
                rightToLeft: true,
                showTicks: true,
                showTicksValues: true,
                disabled: false,
                onEnd: this.estimate.bind(this),
                translate: (value) => `${value}%`,
            },
        }
    }

    $onChanges(changes) {
        if (changes.store) {
            this.factorCons = changes.store.currentValue.consumptionView.consumptionForm.factorCons
            this.potSlider.disabled = changes.store.currentValue.potView.isUpdating
        }
    }

    openPotDetail() {
        this.onDispatch({ $event: { type: 'OPEN_RESULT_POT_DETAIL' } })
    }

    hoverOnCardBill() {
        this.onDispatch({ $event: { type: 'HOVER_ON_CARD_BILL' } })
    }

    hoverOnCardPot() {
        this.onDispatch({ $event: { type: 'HOVER_ON_CARD_POT' } })
    }

    estimate() {
        this.onDispatch({
            $event: (dispatch, getState) => {
                dispatch({ type: 'UPDATE_QUOTATION_POT', factorCons: this.factorCons })
                this.contractDraftService.getQuotation({ return: 'pot' }, angular.copy(getState().quotation.consumptionView.consumptionForm))
                .$promise
                .then((quotationResult) => {
                    dispatch({ type: 'UPDATE_QUOTATION_POT_DONE', pot: quotationResult.pot })
                })
                .catch((error) => {
                    this.errorCatcher.catchError(error)
                    dispatch({ type: 'UPDATE_QUOTATION_POT_ERROR', error })
                })
            },
        })
    }
}

export default {
    template: require('./quotationResultPot.jade')(),
    controller: QuotationResultPotComponent,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationResultPot.js